import { FsSpartacusViewComponentsModule } from 'fs-spartacus-view-components'
import { MbConstants } from '../shared/mb-constants'
import { environment } from '../../../environments/environment'
import { FirstSpiritManagedPage, fromSlotList } from 'fs-spartacus-common'
import { PageType } from '@spartacus/core'
import { CountryService } from '../site-context/facade/country.service'
import { NgModule } from '@angular/core'
import { FsSpartacusBridgeModule } from 'fs-spartacus-bridge/dist/fs-spartacus-bridge'
import { CommonModule } from '@angular/common'

const bridgeConfig = {
  fallbackLanguage: `${MbConstants.FALLBACK_LANGUAGE}_${MbConstants.FALLBACK_COUNTRY}`,
  caas: {
    baseUrl: environment.caasbaseUrl,
    project: environment.caasProject,
    apiKey: environment.caasApiKey,
    tenantId: environment.caasTenantId
  },
  firstSpiritManagedPages: [
    FirstSpiritManagedPage.enhanceSapPages('ErrorPageTemplate',
      fromSlotList('TopContent')),
    FirstSpiritManagedPage.enhanceSapPages('ContentPage1Template',
      fromSlotList('BottomHeaderSlot', 'Section2A', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('SearchResultsListPageTemplate',
      fromSlotList('BottomHeaderSlot', 'Section2', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('LandingPage2Template',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.enhanceSapPages('StoreFinderPageTemplate',
      fromSlotList('BottomHeaderSlot', 'MiddleContent', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('CartPageTemplate',
      fromSlotList('BottomHeaderSlot', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('CategoryPageTemplate',
      fromSlotList('BottomHeaderSlot', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('ProductListPageTemplate',
      fromSlotList('BottomHeaderSlot', 'PreFooterSlot')),
    FirstSpiritManagedPage.enhanceSapPages('ProductDetailsPageTemplate', fromSlotList('Summary', 'UpSelling', 'CrossSelling',
      'Tabs', 'PlaceholderContentSlot')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'applicationpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'applicationprotocolspage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'applicationprotocolpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'backgroundpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'congresspage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'contentpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'homepage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'instrumentpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'miltenyiuniversity',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'productlandingpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'seolandingpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'macshandbookpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'categorypage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'developertemplate',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'manualpdp',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'faqpage',
      fromSlotList('main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'jobdetailpage',
      fromSlotList('header', 'main')),
    FirstSpiritManagedPage.integrateFsDrivenPagesIntoSapSkeleton('contentpageff', PageType.CONTENT_PAGE, 'pouploadtemplate',
      fromSlotList('header', 'main')),
  ]
}

@NgModule({
  imports: [
    CommonModule,
    FsSpartacusViewComponentsModule,
    FsSpartacusBridgeModule.withConfig({
        bridge: {
          miltenyiWebshopBE: bridgeConfig,
          miltenyiWebshopLU: bridgeConfig,
          miltenyiWebshopNL: bridgeConfig,
          miltenyiWebshopDE: bridgeConfig,
          miltenyiWebshopAT: bridgeConfig,
          miltenyiWebshopES: bridgeConfig,
          miltenyiWebshopFR: bridgeConfig,
          miltenyiWebshopIT: bridgeConfig,
          miltenyiWebshopDK: bridgeConfig,
          miltenyiWebshopFI: bridgeConfig,
          miltenyiWebshopLV: bridgeConfig,
          miltenyiWebshopNO: bridgeConfig,
          miltenyiWebshopSE: bridgeConfig,
          miltenyiWebshopUK: bridgeConfig,
          miltenyiWebshopIE: bridgeConfig,
          miltenyiWebshopUS: bridgeConfig,
          miltenyiWebshopCA: bridgeConfig,
          miltenyiWebshopAU: bridgeConfig,
          miltenyiWebshopSG: bridgeConfig,
          miltenyiWebshopKR: bridgeConfig,
          miltenyiWebshopCN: bridgeConfig,
          miltenyiWebshopJP: bridgeConfig,
          miltenyiWebshopHK: bridgeConfig,
          miltenyiWebshopCH: bridgeConfig,
          miltenyiWebshopLI: bridgeConfig,
          miltenyiWebshopUN: bridgeConfig,
          miltenyiWebshopIN: bridgeConfig,
        },
      },
      CountryService
    )
  ],
})
export class CmsConfigModule {
}
